import { v4 } from 'uuid';
const UUID_REGEX = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/gi;

export function uuid(): string {
  return v4();
}

// async to defer the error to the promiseAllSettledObject
export function extractUuid(url: string): string {
  const results = url.match(UUID_REGEX);
  if (!results) {
    throw new Error('No uid found in url');
  }

  return results[0];
}
